import { get } from 'lodash';

class Cart {
  constructor() {
    this.orderMap = {
      sessionkey: 'SessionKey',
      order_no: 'Id',
      appeal_no: 'Appeal.Id',
      source_no: 'Source.Id',
      customer_no: 'Constituent.Id',
      solicitor: 'Solicitor',
      MOS: 'ModeOfSale.Id',
      order_dt: 'OrderDateTime',
      order_total: 'CartAmount',
      order_value: 'SubTotal',
      db_status: 'DbStatus',
      amt_to_charge: 'BalanceToCharge',
      first_seat_added_dt: 'FirstSeatAddedDateTime',
      amt_paid_to_dt: 'AmountPaidPreviously',
      amt_paid_now: 'AmountPaidNow',
      balance_to_charge: 'BalanceToCharge',
      subTotal: 'SubTotal',
      HandlingCharges: 'OrderFees'
    };

    this.lineItemMap = {
      li_seq_no: 'Performance.LineItem.Id',
      li_no: 'Performance.LineItem.Id',
      pkg_no: 'Performance.LineItem.Package.Id',
      perf_no: 'Performance.LineItem.Performance.Id',
      zone_no: 'Performance.LineItem.SubLineItems.0.Zone.Id',
      alt_upgrd_ind: 'Performance.LineItem.AlternateUpgrade',
      primary_ind: 'Performance.LineItem.Primary',
      perf_code: 'Performance.LineItem.Performance.Code',
      perf_dt: 'Performance.LineItem.Performance.PerformanceDateTime',
      perf_desc: 'Performance.LineItem.Performance.Description',
      facility_desc: 'Performance.LineItem.Performance.Facility.Description',
      season_no: 'Performance.LineItem.Performance.Season.Id',
      season_desc: 'Performance.LineItem.Performance.Season.Description',
      facility_no: 'Performance.LineItem.Performance.Facility.Id'
    };

    this.subLineItemMap = {
      sli_no: 'Id',
      li_seq_no: 'Performance.LineItem.Id',
      due_amt: 'SubLineItemDetails.DueAmount',
      paid_amt: 'SubLineItemDetails.PaidAmount',
      price_type: 'PriceType.Id',
      seat_no: 'Seat.Id',
      perf_no: 'Performance.LineItem.Performance.Id',
      pkg_no: 'Performance.LineItem.Package.Id',
      zone_no: 'Zone.Id',
      seat_row: 'Seat.Row',
      seat_num: 'Seat.Number',
      zone_desc: 'Zone.Description',
      section_desc: 'Seat.Section.Description',
      section_short_desc: 'Seat.Section.ShortDescription',
      section_print_desc: 'Seat.Section.PrintDescription',
      db_status: 'DbStatus',
      prod_season_no: 'Performance.LineItem.Performance.ProductionSeason.Id',
      facility_no: 'Performance.LineItem.Performance.Facility.Id'
    };

    this.packageLineItemMap = {
      li_seq_no: 'Package.Id',
      li_no: 'Package.Id',
      perf_no: 'Package.LineItem.Package.Id',
      pkg_no: 'Package.LineItems.0.Package.Id',
      zone_no: 'Package.LineItems.0.SubLineItems.0.Zone.Id',
      alt_upgrd_ind: 'Package.LineItems.0.AlternateUpgrade',
      primary_ind: 'Package.LineItems.0.Primary',
      perf_code: 'Package.LineItems.0.Package.Code',
      perf_dt: 'Package.LineItems.0.Package.Date',
      perf_desc: 'Package.LineItems.0.Package.Description',
      facility_desc: 'Package.LineItems.0.Package.Facility.Description',
      season_no: 'Package.LineItems.0.Package.Season.Id',
      season_desc: 'Package.LineItems.0.Package.Season.Description',
      facility_no: 'Package.LineItems.0.Package.Facility.Id'
    };

    this.packageSubLineItemMap = {
      sli_no: 'Id',
      li_seq_no: 'Package.Id',
      due_amt: 'SubLineItemDetails.DueAmount',
      paid_amt: 'SubLineItemDetails.PaidAmount',
      price_type: 'PriceType.Id',
      seat_no: 'Seat.Id',
      pkg_no: 'Package.LineItems.0.Package.Id',
      zone_no: 'Zone.Id',
      seat_row: 'Seat.Row',
      seat_num: 'Seat.Number',
      zone_desc: 'Zone.Description',
      section_desc: 'Seat.Section.Description',
      section_short_desc: 'Seat.Section.ShortDescription',
      section_print_desc: 'Seat.Section.PrintDescription',
      db_status: 'DbStatus'
    };
  }

  map(cart) {
    let orderDetails = {};
    let lineItems = [];
    let subLineItems = [];
    let packageLineItems = [];
    let packageSubLineItems = [];

    for (let p in this.orderMap) {
      orderDetails[p] = get(cart, this.orderMap[p].split('.'));
    }

    if (!cart.Products) {
      return false;
    }

    for (let x = 0; x < cart.Products.length; x++) {
      let theLineItem = {};
      let _ref = cart.Products[x];
      // Packages
      if (_ref.Performance === null) {
        for (let p in this.lineItemMap) {
          theLineItem[p] = get(_ref, this.packageLineItemMap[p].split('.'));
        }
        packageLineItems.push(theLineItem);

        // Do sub line items at the same time
        for (let z = 0; z < _ref.Package.LineItems.length; z++) {
          let _refz = _ref.Package.LineItems[z];
          for (let b = 0; b < _refz.SubLineItems.length; b++) {
            let _refb = _refz.SubLineItems[b];
            let theSubLineItem = {};
            for (let q in this.packageSubLineItemMap) {
              let mapping = this.packageSubLineItemMap[q];
              if (mapping.indexOf('Package') !== -1) {
                theSubLineItem[q] = get(_ref, mapping.split('.'));
              } else {
                theSubLineItem[q] = get(_refb, mapping.split('.'));
              }
            }
            packageSubLineItems.push(theSubLineItem);
          }
        }

        // Performances
      } else {
        for (let p in this.lineItemMap) {
          theLineItem[p] = get(_ref, this.lineItemMap[p].split('.'));
        }
        lineItems.push(theLineItem);

        // Do sub line items at the same time
        for (
          let z = 0;
          z < _ref.Performance.LineItem.SubLineItems.length;
          z++
        ) {
          let _refz = _ref.Performance.LineItem.SubLineItems[z];
          let theSubLineItem = {};
          for (let q in this.subLineItemMap) {
            let mapping = this.subLineItemMap[q];
            if (mapping.indexOf('Performance') !== -1) {
              theSubLineItem[q] = get(_ref, mapping.split('.'));
            } else {
              theSubLineItem[q] = get(_refz, mapping.split('.'));
            }
          }
          subLineItems.push(theSubLineItem);
        }
      }
    }

    return {
      Order: orderDetails,
      LineItem: lineItems,
      SubLineItem: subLineItems,
      PackageLineItem: packageLineItems,
      PackageSubLineItem: packageSubLineItems
    };
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/JSONAPI/maps/Cart.js